/**
 * @notes: State of the authentication container
 */

import { LANGUAGE } from "fieldpro-tools";
import { Cookies } from "react-cookie";

import { IAuthenticationState } from "containers/authentication/redux/reducer";
import { EMPTY_ACCESS_RIGHT_PROFILE } from "model/application/ActionCode";

const DISPLAY_LANG_COOKIE = "display_lang";

const readDisplayLangFromCookie = (): LANGUAGE | undefined => {
  const cookies = new Cookies();
  const value = cookies.get(DISPLAY_LANG_COOKIE);
  if (Object.values(LANGUAGE).includes(value as LANGUAGE)) {
    return value as LANGUAGE;
  }
  return undefined;
};

export function createInitialAuthState(): IAuthenticationState {
  return {
    loggingOut: false,
    retryWait: false,
    smalaToken: null,
    attempts: 0,
    isPasswordRecovering: false,
    user: {
      id: "",
      isAuthenticated: false,
      email: "",
      keepSignedIn: true,
      picture: undefined,
    },
    loginError: false,
    errorMessage: "",
    errors: [],
    availableActions: {},
    accessRightProfile: EMPTY_ACCESS_RIGHT_PROFILE,
    lastCallToCheckVersion: new Date(0),
    isUsingLastVersion: true,
    lang: LANGUAGE.en,
    displayLang: readDisplayLangFromCookie(),
    SigningUp: false,
    screenMessages: {
      displaySwitchToWebMessage: {
        lastShown: null,
        show: false,
      },
    },
  };
}

const initialState = createInitialAuthState();

export default initialState;
